import { useMutation } from '@tanstack/react-query';

import { type LineupItemPayload } from '@app/client/common/structs/fantasy';
import { callAddLineupItem } from '@app/client/resources/fantasy/lineup';

type MutationParams = {
    value: LineupItemPayload;
};
export function useAddLineupItemMutation() {
    return useMutation({
        mutationFn: ({ value }: MutationParams) => callAddLineupItem({ value }),
    });
}
